// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixed-height[data-v-431a3a30] {\n    padding-top: 0.2rem !important;\n    padding-bottom: 0.2rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
